/* 
 * Export component file to be used on project
*/

import Textarea from './Textarea.js';
export default Textarea;
